import styled from "styled-components";

export const ContainerAddTech = styled.section`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 1.25rem;

  h3 {
    font-size: var(--sz-title-3);
  }

  button {
    width: 3.125rem;
    height: 3.125rem;

    svg {
      font-size: 1.25rem;
    }
  }
`;
